
import { PixelScriptMetadata } from "../../UpdatePixelScript";
import { getStandardTrackingScript } from "./scripts/standard-script";
import { getDebugTrackingScript } from "./scripts/debug-script";
import { getDisabledTrackingScript } from "./scripts/disabled-script";
import { getTestScriptForPixel } from "./scripts/test-script";

export const ScriptFormatter = {
  /**
   * Generates a standard tracking script without integrity attribute
   */
  getTrackingScript: (pixelId: string, scriptMetadata: PixelScriptMetadata | null) => {
    return getStandardTrackingScript({ pixelId, scriptMetadata });
  },

  /**
   * Generates a debug tracking script without integrity attribute
   */
  getDebugTrackingScript: (pixelId: string, scriptMetadata: PixelScriptMetadata | null) => {
    return getDebugTrackingScript({ pixelId, scriptMetadata });
  },

  /**
   * Generates a tracking script with tracking disabled, without integrity attribute
   */
  getDisabledTrackingScript: (pixelId: string, scriptMetadata: PixelScriptMetadata | null) => {
    return getDisabledTrackingScript({ pixelId, scriptMetadata });
  },
  
  /**
   * Generates a test script for the validator without integrity attribute
   */
  getTestScriptForPixel: (pixelId: string) => {
    return getTestScriptForPixel(pixelId);
  }
};
